var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgChevronRight = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 12.5 12.5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.86,6.59a.47.47,0,0,0,0-.66h0L4.12.15a.45.45,0,0,0-.66,0h0L2.69.92a.45.45,0,0,0,0,.66h0L7.32,6.26,2.69,10.94a.45.45,0,0,0,0,.66h0l.77.77a.45.45,0,0,0,.66,0h0Z"
})));
export default SvgChevronRight;